import { Outlet } from "react-router-dom";
import { CustomRatesContextProvider } from "./CustomRatesContext";

export const CustomRatesRoute = () => (
  <CustomRatesContextProvider>
    <Outlet />
  </CustomRatesContextProvider>
);